/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCarrierLaneRate.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/carrier-lane-rate";

export class AutogenModelCarrierLaneRate<RowType extends ModelRow> extends Endpoint<RowType, RowCarrierLaneRateFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCarrierLaneRate extends ModelRow<RowCarrierLaneRateFields> {
	constructor(values?: Partial<RowCarrierLaneRateFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCarrierLaneRateFields {
	carrier_rate_id: number;
	commitment_amount: number;
	commitment_frequency: string;
	commitments_met: number;
	commitments_offered: number;
	company_id: string;
	contact_email: string;
	contact_name: string;
	contact_phone: string;
	customer_fuel_descr: string;
	deduct_code_descr: string;
	descr: string;
	destination_city: string;
	destination_cityid: number;
	destination_state: string;
	destination_type: string;
	destination_value: string;
	destination_zip: string;
	effective_date: Date;
	expiration_date: Date;
	extra_stop_pay: number;
	extra_stop_pay_c: string;
	extra_stop_pay_d: Date;
	extra_stop_pay_deduct_code: string;
	extra_stop_pay_n: number;
	extra_stop_pay_r: number;
	fuel_surcharge_pay: string;
	id: string;
	last_if_commitments_met: string;
	last_used_date: Date;
	max_pay_method: string;
	max_pay_rate: string;
	minimum_pay: number;
	minimum_pay_c: string;
	minimum_pay_d: Date;
	minimum_pay_n: number;
	minimum_pay_r: number;
	origin_city_id: number;
	origin_city_name: string;
	origin_state: string;
	origin_type: string;
	origin_value: string;
	origin_zip: string;
	priority: number;
	pt_to_pt: string;
	rate: string;
	rate_method: string;
	target_pay_method: string;
	target_pay_rate: string;
	times_used: number;
}

